import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { filter, take } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";
import { TokenService } from './services/token.service';
import { SharedService } from './services/shared.service';
import { AppConfigService } from './services/core/appConfig.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  title = 'TARIFA_front';

  userConected: boolean = false;

  loading: boolean = false;

  constructor(private router: Router, private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private tokenService: TokenService,
    private sharedService: SharedService,
    private appConfigService: AppConfigService) {
    this.translate.addLangs(['es', 'ca', 'en']);
    this.translate.setDefaultLang('ca');
    this.translate.use('ca');
  }

  ngOnInit(): void {

    this.appConfigService.getConfig()

    if (!this.tokenService.getAccesToken()) {
      this.activatedRoute.queryParams.subscribe(data => {
        // Se encarga de recibi el 'code' enviado desde la UOC para realizar el login inicial.
        if (data['code'] != null) {
          this.generateToken(data['code']); 
        }
      });
    }
  }

  @ViewChild('navbar') navbar!: NavbarComponent;

  ngAfterViewInit(): void {
    // Nos suscribimos al evento de navegación y validamos el rol al navegar
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Aquí llamas a la función que valida el admin después de cada navegación
        //this.navbar.validateAdmin();
      });
  }


  /**
   * Función encargada de realizar la petición hacia el Keycloack de la UOC para obtener el token
   * @param code 
   */
  generateToken(code: string): void {
    this.tokenService.getToken(code).subscribe({
      next: response => {
        // Se almacena el id_token para poder enviarlo posteriormente el cerrar la sesión de KeyCloack
        localStorage.setItem('id_token', response.id_token);
        this.tokenService.setToken(response.access_token, response.refresh_token);
        this.tokenService.obtainRoleUser(this.tokenService.obtainEmployeeNumber()).subscribe({
          next: response => {
            localStorage.removeItem('noUser')
            if (response.roles.includes('ROLE_ADMIN')) {
              this.sharedService.setAdminStatus(response.roles.includes('ROLE_ADMIN'));
              // Cuando refrescamos la página se pierde el estado en memoria, para evitar eso, lo almacenamos tambien en localStorage
              localStorage.setItem('isAdmin', JSON.stringify(true));
            }
            this.userConected = this.tokenService.isAuthenticate();
            this.router.navigate(['/front', 'welcome']).then(() => {
              sessionStorage.removeItem('loginStarted');
              this.router.navigate([], { queryParams: {}, replaceUrl: true });
              // Notificamos a la subscripción para poder mostrar la web
              this.sharedService.notifyPageInit();
            });
          }, error: error => {
            localStorage.setItem('noUser', error.error.message);
            sessionStorage.removeItem('loginStarted');
            this.tokenService.clearToken();
            this.router.navigate(['/front', 'noUser']);
          }
        });
      }, error: error => {
        if (error.error == "invalid_grant") {
          sessionStorage.removeItem('loginStarted');
          this.router.navigate(['']);
        }
      }
    })
  }

  validateTokenExpired(): boolean {
    const validate = this.tokenService.isAuthenticate();
    if (!validate) {
      this.userConected = false;
      this.tokenService.clearTokenWithCookie();
    }
    return validate;
  }


}
